import { render, staticRenderFns } from "./NauticalCategorySchool.vue?vue&type=template&id=1ae532b7&scoped=true"
import script from "./NauticalCategorySchool.vue?vue&type=script&lang=js"
export * from "./NauticalCategorySchool.vue?vue&type=script&lang=js"
import style0 from "./NauticalCategorySchool.vue?vue&type=style&index=0&id=1ae532b7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae532b7",
  null
  
)

export default component.exports